import { GoLocation } from "react-icons/go";
import parseDropDownValue from "../../../../controllers/utils/parseDropDownValue";
import { useTranslation } from "react-i18next";
import CardForItemCompact from "../../../applicationUI/CardForItemCompact";
import accountTypes from "../../../../data/accountTypes";
import goTo from "../../../../controllers/goTo";
import { LuBox } from "react-icons/lu";
import styled from "styled-components";
import getImageURL from "../../../../controllers/getImageURL";
import CustomButton from "../../../helperComponents/CustomButton";
import { useState } from "react";
import { serverLine } from "../../../../controllers/network/serverLine";
import CustomLabel from "../../../applicationUI/CustomLabel";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 5px;
`;

const Buttons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export default function ProfileCardForDocumentVerification({ data }) {
  const [decisionTaken, setDecisionTaken] = useState(false);

  const { t } = useTranslation();

  if (decisionTaken) return null;

  return (
    <CardForItemCompact
      data={data}
      isProfile={true}
      image={data.profileImage}
      itemType={"PROFILE"}
      itemId={data._id}
      title={`${data.name}`}
      line1={[
        {
          text: `${data.bio}`,
        },
      ]}
      line2={[
        data.state && {
          icon: <GoLocation />,
          text: `${data.state}`,
        },

        data.city && {
          icon: <GoLocation />,
          text: `${data.city}`,
        },
        {
          icon: <LuBox />,
          text: `${
            parseDropDownValue({
              query: data.accountType,
              theArray: accountTypes,
            }) || "NA"
          }`,
        },
      ]}
      attachedComponent={
        <Container>
          <CustomLabel>Verification Document</CustomLabel>
          <Image src={getImageURL(data.documentVerification)} />

          <Buttons>
            <CustomButton onClick={setDocVerStatus("APPROVED")}>
              Approve
            </CustomButton>
            <CustomButton onClick={setDocVerStatus("DECLINED")}>
              Decline
            </CustomButton>

            <CustomButton onClick={goTo(`/u/${data.username}`)}>
              Open Profile
            </CustomButton>
          </Buttons>
        </Container>
      }
    />
  );

  function setDocVerStatus(decision) {
    return () => {
      setDecisionTaken(true);
      serverLine.post("/doc-verification-decision", {
        itemId: data._id,
        decision,
      });
    };
  }
}
